/* eslint-disable react/jsx-max-props-per-line */
import React, { useState } from 'react';
import { Alert, Link, Typography } from '@mui/material';
import ExemploRegraDialog from './ExemploRegraDialog';

/** Texto fixo: explica a regra sem repetir o que foi selecionado. O exemplo abre num dialog. */
const AvisoRegra = () => {
  const [exemploAberto, setExemploAberto] = useState(false);

  return (
    <>
      <Alert severity="info" sx={{ py: 0.25 }}>
        <Typography variant="body2">
          <strong>Campo preenchido restringe o card</strong> aos valores escolhidos;{' '}
          <strong>campo em branco</strong> vale para qualquer NSMP. Com mais de um campo preenchido,
          a NSMP precisa combinar com todos.{' '}
          <Link
            component="button"
            type="button"
            variant="body2"
            underline="always"
            onClick={() => setExemploAberto(true)}
            sx={{ verticalAlign: 'baseline', fontWeight: 600 }}
          >
            Ver exemplo
          </Link>
        </Typography>
      </Alert>
      <ExemploRegraDialog
        open={exemploAberto}
        onClose={() => setExemploAberto(false)}
      />
    </>
  );
};

export default AvisoRegra;
